import { controls } from "../../controls";
const rprbi14 = {
  label: "Investment Credit Disbursement",
  starting: true,
  url: "Investment Credit Disbursement",
  pageLabel: "Investment Credit Disbursement",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "From Date", width: "col-sm-2", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),

    ...controls.magicDateLabel({ tab: "filter", label: "As on Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI Investment Credit Disbursement",
    filterable: true,
    sortable: true,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },

    textReportProps: {
      'LBS': {
        filename: `RBI-Investment_Credit_Disbursement-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    defaultsTo: 0,

    displayColumns: [
      {
        Header: "Branch Code",
        accessor: "branch_code",
      },
      {
        Header: "Branch Name",
        accessor: "branch_display",
      },
      {
        Header: "KCC AC for animal husbandry and allied activitie",
        accessor: "quarter_cnt",
      },
      {
        Header: "KCC Amount for animal husbandry and allied activitie",
        accessor: "disbursed_amt",
      },
      {
        Header: "Farm Production organistaion AC",
        accessor: "farmprodcnt",
      },
      {
        Header: "Farm Production organistaion Amount",
        accessor: "farmprodamt",
      },
      {
        Header: "Dairy Dev AC",
        accessor: "dairycnt",
      },
      {
        Header: "Dairy Dev Amount",
        accessor: "dairyamt",
      },
      {
        Header: "Farm Mechanisation A/c",
        accessor: "mechquarter_cnt",
      },
      {
        Header: "Farm Mechanisation Amount",
        accessor: "mechdisbursed_amt",
      },
      {
        Header: "Poultry A/C",
        accessor: "poultrycnt",
      },
      {
        Header: "Poultry Amount",
        accessor: "poultryamt",
      },
      {
        Header: "Fisheries A/C",
        accessor: "fishcnt",
      },
      {
        Header: "Fisheries Amount",
        accessor: "fishamt",
      },
      {
        Header: "Rural Godown A/C",
        accessor: "godowncnt",
      },
      {
        Header: "Rural Godown Amount",
        accessor: "godownamt",
      },
      {
        Header: "Agri Clinic A/C",
        accessor: "cliniccnt",
      },
      {
        Header: "Agri Clinic Amount",
        accessor: "clinicamt",
      },
      {
        Header: "Other A/C",
        accessor: "othercnt",
      },
      {
        Header: "Other Amount",
        accessor: "otheramt",
      },
    ]
  }
};
export default rprbi14;